import { Box, Paper, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Controller, useFormContext } from 'react-hook-form';

type DatosGeneralesFields = {
  fecha_analisis: Date;
  identificacion_muestras: string | null;
  alimentacion: string | null;
  ultimo_antiparasitario: string | null;
  fecha_ultimo_tratamiento: Date | null;
  comentarios_lote: string | null;
};

interface AnalisisDatosGeneralesFormProps {
  noPaper?: boolean;
}

export function AnalisisDatosGeneralesForm({ noPaper = false }: AnalisisDatosGeneralesFormProps): JSX.Element {
  const { control } = useFormContext<DatosGeneralesFields>();

  const grid = (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
        gap: noPaper ? 1.5 : 2,
      }}
    >
        <Controller
          control={control}
          name="fecha_analisis"
          render={({ field, fieldState }) => (
            <DatePicker
              label="Fecha de análisis *"
              value={field.value}
              onChange={(date) => field.onChange(date)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                  required: true,
                  error: !!fieldState.error,
                  helperText: fieldState.error?.message,
                  onBlur: field.onBlur,
                },
              }}
            />
          )}
        />

        <Controller
          control={control}
          name="identificacion_muestras"
          render={({ field }) => (
            <TextField
              label="Identificación de muestras"
              size="small"
              fullWidth
              placeholder="Lote NOVILLOS - 320 cab."
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value !== '' ? e.target.value : null)}
              onBlur={field.onBlur}
            />
          )}
        />

        <Controller
          control={control}
          name="alimentacion"
          render={({ field }) => (
            <TextField
              label="Alimentación"
              size="small"
              fullWidth
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value !== '' ? e.target.value : null)}
              onBlur={field.onBlur}
            />
          )}
        />

        <Controller
          control={control}
          name="ultimo_antiparasitario"
          render={({ field }) => (
            <TextField
              label="Último antiparasitario"
              size="small"
              fullWidth
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value !== '' ? e.target.value : null)}
              onBlur={field.onBlur}
            />
          )}
        />

        <Controller
          control={control}
          name="fecha_ultimo_tratamiento"
          render={({ field, fieldState }) => (
            <DatePicker
              label="Fecha último tratamiento"
              value={field.value}
              onChange={(date) => field.onChange(date)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                  error: !!fieldState.error,
                  helperText: fieldState.error?.message,
                  onBlur: field.onBlur,
                },
              }}
            />
          )}
        />

        <Box sx={{ gridColumn: { sm: '1 / -1' } }}>
          <Controller
            control={control}
            name="comentarios_lote"
            render={({ field }) => (
              <TextField
                label="Comentarios del lote"
                size="small"
                fullWidth
                multiline
                rows={3}
                value={field.value ?? ''}
                onChange={(e) => field.onChange(e.target.value !== '' ? e.target.value : null)}
                onBlur={field.onBlur}
              />
            )}
          />
        </Box>
      </Box>
  );

  if (noPaper) return grid;

  return (
    <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Datos del análisis
      </Typography>
      {grid}
    </Paper>
  );
}
